import validateQuantityDiscount from './validateQuantityDiscount';
const validateQuantityDiscount2 = product => {
    if (
        validateQuantityDiscount(product) &&
        //Validate amount of items ordered
        product.ca2 > 1 &&
        product.ca2 > product.ca1 &&
        // Quantity Discount 2 is greater than the first one
        product.po2 > product.bonif1 &&
        product.po2 > product.po1 &&
        product.po2 - product.po1 !== 0
    ) {
        return true;
    }
    return false;
};

export default validateQuantityDiscount2;
